export default "__VITE_ASSET__qkay4s0c__"